import React from "react";
import "./NewsSection.scss";
import CulturalDiversityImage from "../../assets/NewsImages/CulturalDiversity/culturalDiversityMain.png";
import BookCharacterImage from "../../assets/NewsImages/BookCharacterDay/bookMain.jpg"
import PFCImage from "../../assets/NewsImages/PFC/pfcMain.jpg";
import ChocolateMain from "../../assets/NewsImages/Chocolate/chocolateMain.png"
import CommunityMain from "../../assets/NewsImages/Community/communityMain.jpg"
import SummerCampMain from "../../assets/NewsImages/SummerCamp/summer_camp.jpeg"
import GmhlMain from "../../assets/NewsImages/GMHL/gmhl10.jpeg"
import EduSummitMain from "../../assets/NewsImages/EduSummit/summit1.jpeg"
import { Link } from "react-router-dom";

const NewsSection = () => {
  const news = [
    {
      slug: "ghana-my-homeland",
      image: GmhlMain,
      date: "Friday 14th June, 2024",
      title: "GHANA MY HOMELAND",
      description:
        "As part of their Oral & Auditory lessons on Ghana and its history, the Reception and Year 1 classes held an event dubbed 'Ghana My Homeland' on Friday, June 14th, 2024, to showcase their knowledge about Ghana and celebrate its forefathers and their immense contributions in the fight for independence. ",
    },
    {
      slug: "education-summit",
      image: EduSummitMain,
      date: "Friday 5th to Sunday 7th July, 2024",
      title: "EDUCATION SUMMIT",
      description:
        "From time immemorial, education has played a significant role in shaping nations. In the 21st century, education has seen numerous positive changes that have brought about great transformation worldwide, especially in Ghana. ",
    },
    {
      slug: "summer-camp",
      image: SummerCampMain,
      date: "Monday 29th July to Friday 16th August, 2024",
      title: "SUMMER CAMP",
      description:
        "We are thrilled to introduce the 2024 Anell School of Excellence Summer Camp Program, catering to children aged 2 to 12, both ANELL and non-ANELL.",
    },
    {
      slug: "book-character-day",
      image: BookCharacterImage,
      date: "12th March, 2024",
      title: "BOOK CHARACTER DAY",
      description:
        "To celebrate our students' love for storytelling and comic books, we organized a lively event known as Book Character Day. This special day, held on March 12th, 2024, saw our school transformed into a vibrant showcase of beloved literary and comic book heroes.",
    },
    {
      slug: "cultural-diversity-day",
      image: CulturalDiversityImage,
      date: "5th March, 2024",
      title: "CULTURAL DIVERSITY DAY",
      description:
        "This year's Cultural Diversity Day at our school, held on March 5th, 2024, was a vibrant celebration of unity and cultural heritage. Throughout the day, students and staff came together to honor the rich tapestry of ethnic groups represented within our school community",
    },
    
    {
      slug: "parent-facilitator-conference",
      image: PFCImage,
      date: "11th March, 2024",
      title: "PARENT FACILITATOR CONFERENCE & BOOK FAIR",
      description:
        "To demonstrate our commitment to parental involvement in their children's education, we host an annual event known as the Parent-Facilitator Conference. This year’s event took place on Monday, March 11th, 2024, to serve as an opportunity for parents to actively engage with facilitators to gain insights into their children's academic progress and well-being.",
    },
    {
      slug: "ghana-chocolate-day",
      image: ChocolateMain,
      date: "14th February, 2024",
      title: "GHANA CHOCOLATE DAY",
      description:
        'The school celebrated Ghana Chocolate Day with a unique and engaging approach, focusing on the theme "The Relevance of Ghanaian Cocoa and the Impact of Galamsey." On Wednesday, February 14th, 2024, staff and students alike arrived at school dressed in vibrant red attire to signify the importance of the occasion. ',
    },
    {
      slug: "community-helpers-day",
      image: CommunityMain,
      date: "23rd February, 2024",
      title: "COMMUNITY HELPERS DAY",
      description:
        "On February 23rd, 2024, the Foundation class held its inaugural event, aptly titled Community Helpers Day. This special occasion aimed to express gratitude to the various community helpers in our country and underscore the importance of their invaluable contributions.",
    },

  ];
  return (
    <div id="news" className="main-container">
      <div className="news-items">
        {news.map((newsItem, index) => (
          <div className="news-item" key={index}>
            <div
              className="news-item-header"
              style={{ backgroundImage: `url(${newsItem.image})` }}
            >
              {/* <img src={newsItem.image} alt="news-item" /> */}
            </div>
            <div className="news-item-body">
              <div className="date-title">{newsItem.date}</div>
              <div className="news-title">{newsItem.title}</div>
              <div className="news-body">{newsItem.description}</div>
              <Link to={`/news-events/news/${newsItem.slug}`}>READ MORE</Link>
            </div>
          </div>
        ))}
      </div>
      <div className="news-letter-section">
        <div className="news-letter-section-left">
          <h3>Newsletter</h3>
          <p>
          Stay in the know and be the first to hear about the latest news, trends, and exciting developments in your favorite niche! 
          </p>
        </div>
        <div className="news-letter-section-right">
          <form onSubmit={(e)=>e.preventDefault()}>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Enter your email address here"
            />
            <input type="submit" value="SUBSCRIBE NOW" />
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
